(function() {
	'use strict';

	angular.module('advancePaymentApp').controller('AdvancePaymentController',
			AdvancePaymentController);

	AdvancePaymentController.$inject = [ '$scope', '$window',
			'AdvancePaymentService', '$log', 'AlertService', 'NgTableParams',
			'$state', '$stateParams', 'authExpiredInterceptor', '$filter',
			'CommonService', 'Upload', 'entity', '$base64', '$uibModal',
			'REQUEST_ADVANCE_CONST', 'FileNetService', 'CONST_COMMON',
			'$timeout', 'EVENT', 'FORMAT_DATE' ];

	function AdvancePaymentController($scope, $window, AdvancePaymentService,
			$log, AlertService, NgTableParams, $state, $stateParams,
			authExpiredInterceptor, $filter, CommonService, Upload, entity,
			$base64, $uibModal, REQUEST_ADVANCE_CONST, FileNetService,
			CONST_COMMON, $timeout, EVENT, FORMAT_DATE) {
		var advancePaymentCtr = this;
		var self = $scope;
		var param = $stateParams;
		self.loading = false;
		self.isDisable = false;
		self.isCancel = false;
		self.advancePayment = {};
		self.advancePayment.transactionDate = new Date();
		self.advancePayment.transaction = {};
		advancePaymentCtr.files = [];
		advancePaymentCtr.archiveDataIds = [];
		advancePaymentCtr.archiveDataIdsDelete = [];
		advancePaymentCtr.office = {};
		advancePaymentCtr.checkDate = false;
		/**
		 * Init
		 */
		function init() {
			self.advancePayment.transaction.txnType = '2300';
			self.advancePayment.transaction.txnEnable = "1";
			self.advancePayment.requestDate = new Date();
			self.advancePayment.adjustAmount = 0;
			if ($stateParams.taskId != undefined && $stateParams.taskId != '') {
				self.taskInstanceId = $base64.decode($stateParams.taskId);
			}
			if (entity != null) {
				entity.taskInstanceId = self.taskInstanceId;
				self.advancePayment = entity;
				if (entity.archiveDatas != null) {
					for (var int = 0; int < entity.archiveDatas.length; int++) {
						var file = {};
						file.name = entity.archiveDatas[int].dataName;
						file.size = entity.archiveDatas[int].contentType;
						file.type = entity.archiveDatas[int].dataType;
						file.archiveDataId = entity.archiveDatas[int].archiveDataId;
						var obj = {
							'file' : file,
							'archiveDataId' : entity.archiveDatas[int].archiveDataId
						};
						advancePaymentCtr.files.push(obj);
					}

				}
				if ($stateParams.taskId == undefined
						|| $stateParams.taskId == '') {
					self.isDisable = true;
				}
				if (entity.transaction.txnEnable == '0') {
					self.isDisable = true;
					self.isCancel = true;
				}
			} else {
				AdvancePaymentService.get({
					uri : 'getOfficeByUser'
				}, function(result) {
					self.advancePayment.bankCode = result.officeBankCode;
					self.advancePayment.bankName = result.officeName;
					self.advancePayment.officeCode = result.officeCode;
					advancePaymentCtr.bankInfo = self.advancePayment.bankCode
							+ '-' + self.advancePayment.bankName;
				});
			}
		}
		init();

		$scope.$on(EVENT.changeOffice, function(event, args) {
			if (event.name = EVENT.changeOffice) {
				advancePaymentCtr.reset();
				/*
				 * if (self.advancePayment.advancePaymentId == null ||
				 * self.advancePayment.advancePaymentId == undefined ||
				 * self.advancePayment.advancePaymentId == '') {
				 * self.advancePayment.officeCode = args.officeCode;
				 * advancePaymentCtr.getAgentOffice(args.officeCode); }
				 */
			}
		});

		/**
		 * saveAdvancePayment
		 */
		advancePaymentCtr.saveAdvancePayment = function() {
			self.clearMessage();
			advancePaymentCtr.validateDate();
			if (!advancePaymentCtr.checkDate) {

				var data = [];
				self.loading = true;
				if (advancePaymentCtr.files) {
					for (var int = 0; int < advancePaymentCtr.files.length; int++) {
						var array_element = advancePaymentCtr.files[int];
						data['fileAdvancePayment' + int] = array_element;

					}
				}
				data['advancePayment'] = new Blob([ JSON
						.stringify(self.advancePayment) ], {
					type : "application/json"
				});
				Upload
						.upload(
								{
									url : GLOBAL_URL
											+ 'api/ga/advance-payment/do-save?access_token='
											+ authExpiredInterceptor.getToken(),
									data : data
								})
						.then(
								function(resp) {
									self.loading = false;
									if (resp.data.advancePaymentId) {
										self.isDisable = true;
										self.advancePayment.advancePaymentId = resp.data.advancePaymentId;
										if (resp.data.transaction) {
											self.advancePayment.transaction.txnId = resp.data.transaction.txnId;
											self.advancePayment.transaction.txnEnable = '1';
										}
									}

								}, function(resp) {
									self.loading = false;
								}, function(evt) {
									/*
									 * var progressPercentage = parseInt(100.0
									 * evt.loaded / evt.total);
									 * $log.debug('progress: ' +
									 * progressPercentage + '% ' +
									 * evt.config.data.file.name);
									 */
								});
			}
		};

		/*
		 * Get getAgentOffice
		 */
		advancePaymentCtr.getNumToWord = function() {
			if (self.advancePayment.bankAmount == undefined
					|| self.advancePayment.bankAmount == ''
					|| parseFloat(self.advancePayment.bankAmount) == 0)
				return;
			else {
				AdvancePaymentService.returnValue({
					uri : 'get-amount-word',
					advanceAmount : parseFloat(self.advancePayment.bankAmount)
				}, function(result) {
					self.advancePayment.amountAdvanceWord = result.response;
				}, function(error) {

				});
			}
		}

		$scope.$watch('advancePayment.bankAmount', function() {
			if (self.advancePayment.bankAmount != undefined
					&& self.advancePayment.bankAmount != ''
					&& parseFloat(self.advancePayment.bankAmount) > 0) {
				self.advancePaymentForm.bankAmount.$setValidity(
						'amountLessThan0', true);
			} else {
				self.advancePaymentForm.bankAmount.$setValidity(
						'amountLessThan0', false);
			}
		});

		// upload multiple files
		advancePaymentCtr.chooseUploadFiles = function(file) {
			if (file) {
				$scope.clearMessage();
				var obj = {
					'file' : file,
					'archiveDataId' : 0
				}
				if (advancePaymentCtr.files.length >= 4)
					self.addAlert('Tối đa chỉ được đính kèm 4 file.', 'danger');
				else
					advancePaymentCtr.files.push(obj);
				advancePaymentCtr.file = null;
			}
		};
		$scope.$watch('advancePaymentCtr.file', function() {
			advancePaymentCtr.chooseUploadFiles(advancePaymentCtr.file);
		});

		advancePaymentCtr.removeFile = function(index) {
			if (self.advancePayment.advancePaymentId != null
					&& self.advancePayment.advancePaymentId != undefined) {
				advancePaymentCtr.archiveDataIdsDelete
						.push(advancePaymentCtr.files[index].file.archiveDataId);
				self.advancePayment.filesRemove = advancePaymentCtr.archiveDataIdsDelete;
			}
			advancePaymentCtr.files.splice(index, 1);
		};

		// reset
		advancePaymentCtr.reset = function() {
			// https://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_reload
			self.isDisable = false;
			self.clearMessage();
			$state.transitionTo($state.current, {}, {
				reload : true,
				inherit : false,
				notify : true
			});
		}

		// watch model

		// $scope.$watch('advancePayment.policyInfo.ptdRider',
		// function(formattedDate){
		// self.ptdRiderStr = $filter('date')(formattedDate, 'dd/MM/yyyy');
		// });

		advancePaymentCtr.changeCollectionDate = function() {
			if (self.advancePayment.collectionDate != null
					&& self.advancePayment.collectionDate != '') {
				AdvancePaymentService.returnValue({
					uri : 'get-bank-amount',
					collectDate : $filter('date')(
							self.advancePayment.collectionDate, FORMAT_DATE),
					officeCode : self.advancePayment.bankCode
				}, function(result) {
					// self.addAlert(result.response, 'danger');
					self.advancePayment.advancedAmount = result.response;
				});
			}
		};

		// Add days
		Date.prototype.AddDays = function(noOfDays) {
			this.setTime(this.getTime() + (noOfDays * (1000 * 60 * 60 * 24)));
			return this;
		}
		// ------------------
		advancePaymentCtr.datePickerOpenStatus = {};
		advancePaymentCtr.datePickerOpenStatus.fromDate = false;
		advancePaymentCtr.datePickerOpenStatus.toDate = false;
		advancePaymentCtr.openCalendar = openCalendar;
		function openCalendar(date) {
			advancePaymentCtr.datePickerOpenStatus[date] = true;
		}
		advancePaymentCtr.maxDateOptions = {
			maxDate : new Date()
		};
		advancePaymentCtr.mindateOptions = {
			minDate : new Date(self.advancePayment.collectionDate)
		};
		advancePaymentCtr.openFromDate = function() {
			advancePaymentCtr.popupFromDate.opened = true;
		};

		self.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		self.format = $scope.formats[2];
		self.altInputFormats = [ 'M!/d!/yyyy' ];
		advancePaymentCtr.popupFromDate = {
			opened : false
		};

		advancePaymentCtr.downloadFileCurrent = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				var blob = new Blob([ attach ], {
					type : attach.type
				});
				window.navigator.msSaveBlob(blob, attach.name);
			} else {
				// truong hop file da luu duoi database
				var blob = new Blob([ attach ], {
					type : attach.type
				});
				var url = $window.URL || $window.webkitURL;
				var aTag = document.createElement("a");
				aTag.style = "display: none";
				aTag.href = url.createObjectURL(blob);
				aTag.download = attach.name;
				aTag.click();
			}
		};

		advancePaymentCtr.openReportNetOff = function() {
			$window.open(GLOBAL_URL + 'ga/report/#/report-netoff-summary',
					'_blank');
		};

		$scope.$watch('advancePayment.advancedDate', function() {
			advancePaymentCtr.validateDate();
		});

		advancePaymentCtr.validateDate = function() {
			$scope.clearMessage();

			var toDate = moment(self.advancePayment.advancedDate, "DD/MM/YYYY");
			var fromDate = moment(self.advancePayment.collectionDate, "DD/MM/YYYY");
			if (toDate.diff(fromDate) < 0) {
				advancePaymentCtr.checkDate = true;
				$scope
						.addAlert(
								'Vui lòng chọn Ngày trên Giấy nộp tiền lớn hơn hoặc bằng Ngày thu phí.',
								'error');
			} else {
				advancePaymentCtr.checkDate = false;
			}
		};
		
		advancePaymentCtr.alertDialog = function() {
			if(self.advancePayment.adjustAmount == null || self.advancePayment.adjustAmount == '') {
				self.advancePayment.adjustAmount = 0;
			}
			if ((parseInt(self.advancePayment.advancedAmount) + parseInt(self.advancePayment.adjustAmount)) != parseInt(self.advancePayment.bankAmount)) {
				advancePaymentCtr.animationsEnabled = true;
				var modalInstance =
				// show dialog
				$uibModal
						.open({
							animation : advancePaymentCtr.animationsEnabled,
							templateUrl : GLOBAL_URL
									+ 'partial?uri=ga/advance-payment/alert-dialog',
							controller : 'AlertDialogController as alertDlgCtr',
							size : 'lg'
						});
				modalInstance.result.then(function(result) {
					// get id assigner and update db
					advancePaymentCtr.saveAdvancePayment();
				}, function(error) {
				});
			} else {
				advancePaymentCtr.saveAdvancePayment();
			}
			
			
		};
	}

})();
